import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-alert-type',
  templateUrl: './alert-type.component.html',
  styleUrls: ['./alert-type.component.sass']
})
export class AlertTypeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
